import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Campaign } from '../_shared/models/campaign.model';
import { Observable, map } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CampaignsService {
  private http = inject(HttpClient);

  index(filter: any): Observable<Campaign[]> {
    return this.http.post<{data: { campaigns: Campaign[]} }>('api_endpoint' + '/campaign/index', { filter }).pipe(
      map(res => res.data.campaigns)
    );
  }
}
